(function() {

	var Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		Texture = include("PIXI.Texture"),
		Ellipse = include("PIXI.Ellipse");

	var SearchClue = function(state, id)
	{
		this.state = state;

		Sprite.call(this, Texture.fromFrame("clue_" + id));
		
		//set up hit area for detection
		this.hitArea = new Ellipse(0, 0, Math.max(this.width * 0.5, 35),
			Math.max(this.height * 0.5, 35));
		
		//set up extended hit area to make the clue sparkle if just outside the detection area
		var radiusExt = Application.instance.config.game.clues.clueSparkleRadius;
		this.sparkleArea = new Ellipse(0, 0, this.hitArea.width + radiusExt,
			this.hitArea.height + radiusExt);
		
		this.id = id;
		this.anchor.x = this.anchor.y = 0.5;
	};

	// Extend MovieClip
	var s = Sprite.prototype;
	var p = SearchClue.prototype = Object.create(s);
	
	Object.defineProperty(p, "scaleX", {
		get: function() { return this.scale.x; },
		set: function(value)
		{
			this.scale.x = value;
		}
	});
	
	Object.defineProperty(p, "scaleY", {
		get: function() { return this.scale.y; },
		set: function(value)
		{
			this.scale.y = value;
		}
	});

	p.destroy = function()
	{
		this.state = null;
		s.destroy.call(this);
	};

	namespace('heist').SearchClue = SearchClue;
}());